import request from '@/utils/request'
const apiPath = '/tech/technicianServiceOrder'

const technicianServiceOrderApi = {
  /**
   * 分页查询【技术预约管理】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee/list', { params: query })
  },
  fetchForList(query) {
    return request.get(apiPath + '/tee/listPageForMini', { params: query })
  },
  /**
   * 获取状态数量【技术预约服务单】
   */
  getStatusCount(query) {
    return request.get(apiPath + '/tee/getStatusCount', { params: query })
  },
  /**
   * 更新服务时间【技术预约服务单】
   */
  updateServiceTime(data) {
    return request.put(apiPath + '/tee/updateServiceTime', data)
  },
  updateServiceTech(data) {
    return request.put(apiPath + '/tee/updateServiceTech', data)
  },
  // 取消预约
  updateCancel(data){
    return request.put(apiPath + '/tee/cancel', data)
  },
  /**
   * 获取详情【技术预约服务单】
   */
  fetchById(id) {
    return request.get(`${apiPath}/tee/${id}`)
  },
  // 列表查询【技术员（老师）服务单记录】
  getServiceOrder(query){
    return request.get(`${apiPath}Log`, { params: query })
  },
  getServiceOrderList(query){
    return request.get(`${apiPath}Log/tee/list`, { params: query })
  },
  // 导出
  exportExcel(query) {
    return request.get(apiPath + '/tee/export', { params: query })
  },
  // // 获取指标总配额
  // getServiceStatistics(query){
  //   return request.get(`/tech/technicianQuota/tee/getTotalQuota`, { params: query })
  // }
}
export default technicianServiceOrderApi
